import ufeApi from 'services/api/ufeApi';
import userUtils from 'utils/User';
import Empty from 'constants/empty';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Update+Profile+API

function updateProfile(profileData) {
    const isUpdatingPassword = profileData.fragmentForUpdate === 'PASSWORD';
    const request = isUpdatingPassword
        ? {
            url: '/gway/v1/dotcom/auth/v2/users',
            payload: {
                clientId: userUtils.getBiAccountId() || Empty.String,
                password: profileData.password
            }
        }
        : { url: '/gway/v2/users/profiles', payload: profileData };

    return ufeApi
        .makeRequest(request.url, {
            method: 'PUT',
            body: JSON.stringify(request.payload),
            headers: {
                'x-requested-source': 'web',
                'Content-type': 'application/json'
            }
        })
        .then(data => (data.errorCode || data.errors ? Promise.reject(data) : data));
}

export default updateProfile;
